<template>
  <el-dialog
          title="一级代理信息"
          :visible.sync="dialogVisible"
          @opened="dialogOpen"
  >
    <el-form
            ref="form"
            :model="form"
            label-width="150px"
            size="small"
    >
      <el-form-item v-if="formEdit2"
                    prop="userCode"
                    label="登陆名"
                    :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.userCode"></el-input>
      </el-form-item>
      <el-form-item
              prop="legal"
              label="姓名"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.legal"></el-input>
      </el-form-item>
      <el-form-item
              prop="userName"
              label="公司/个人"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.userName"></el-input>
      </el-form-item>
      <!--
      <el-form-item label="证件类型" prop="contractno"  :rules="[{ required: true, message: '不能为空'}]">
        <el-select
                class="filter-item"
                v-model="form.contractno"
                placeholder="证件类型"
                width="50"
        >
          <el-option
                  v-for="item in sfzlxOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="银行开户证件号" prop="identification_number"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.identification_number"></el-input>
      </el-form-item>

      <el-form-item label="有效期" prop="identification_start"  :rules="[{ required: true, message: '不能为空'}]">
        <el-date-picker
                v-model="form.identification_start"
                type="date"
                style="width:150px;"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="至" prop="identification_end" >
        <el-date-picker
                v-model="form.identification_end"
                type="date"
                style="width:150px;"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd">
        </el-date-picker>  <el-checkbox v-model="form.identification_end2">长期</el-checkbox>
      </el-form-item>

      <el-form-item label="证件扫描件" prop="idcards_front"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.idcards_front" style="display:none" ></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :limit=1
                :auto-upload="true"
                :file-list="fileList4"
                :before-upload="handleBeforeUpload"
                :on-remove="handleRemove2"
                :on-success="handlePictureCardPreview2">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>

      <el-form-item label="证件扫描件反面" prop="idcards_back"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.idcards_back" style="display:none" ></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :limit=1
                :auto-upload="true"
                :file-list="fileList5"
                :before-upload="handleBeforeUpload"
                :on-remove="handleRemove3"
                :on-success="handlePictureCardPreview3">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>

      <el-form-item label="请上传银行卡" prop="industry_license"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.industry_license" style="display:none" ></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :limit=1
                :auto-upload="true"
                :file-list="fileList6"
                :before-upload="handleBeforeUpload"
                :on-remove="handleRemove7"
                :on-success="handlePictureCardPreview7">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>

      <el-form-item label="开户名" prop="account_name"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.account_name"></el-input>
      </el-form-item>

      <el-form-item label="开户账号" prop="bank_account"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.bank_account"></el-input>
      </el-form-item>

      <el-form-item label="开户行信息填写" prop="bank_branch"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.deposit_bank" placeholder="请输入开户行(招商银行)"></el-input>
        <el-select
                class="filter-item"
                v-model="form.prov_cd2"
                placeholder="请选择省"
                @change="currentSel_yh(form.prov_cd2)"
        >
          <el-option
                  v-for="item in typeOptions_yh"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
          ></el-option>
        </el-select>
        <el-select
                class="filter-item"
                v-model="form.city2"
                placeholder="请选择市"
                @change="currentSel2_yh(form.city2)"
        >
          <el-option
                  v-for="item in typeOptions2_yh"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"

          ></el-option>
        </el-select>

        <el-select
                class="filter-item"
                v-model="form.bank_branch"
                placeholder="请选择支行"
        >
          <el-option
                  v-for="item in typeOptions3_yh"
                  :key="item.areaname"
                  :label="item.areaname"
                  :value="item.areaname"

          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
              prop="mobileNo"
              label="银行预留手机"  :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.mobileNo" ></el-input>
      </el-form-item>
      <el-form-item
              prop="wechat_no"
              label="微信号（分账）"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.wechat_no"></el-input>
      </el-form-item>-->
      <el-form-item
              prop="mobileNo"
              label="手机号码"  :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.mobileNo" ></el-input>
      </el-form-item>
      <el-form-item
              prop="prov_cd"
              label="省"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.prov_cd"
                placeholder="请选择省"
                @change="currentSel(form.prov_cd)"
        >
          <el-option
                  v-for="item in typeOptions"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="city"
              label="市" :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.city"
                placeholder="请选择市"
                @change="currentSel2(form.city)"
        >
          <el-option
                  v-for="item in typeOptions2"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="areaid"
              label="区" :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.areaid"
                placeholder="请选择区"
        >
          <el-option
                  v-for="item in typeOptions3"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="compaddress"
              label="地址"  :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.compaddress"></el-input>
      </el-form-item>

      <el-form-item
              prop="contractstdate"
              label="合同开始日期"
      >

        <el-date-picker
                v-model="form.contractstdate"
                type="date"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd">
        </el-date-picker>

      </el-form-item>

      <el-form-item
              prop="contractendate"
              label="合同结束日期"
      >
        <el-date-picker
                v-model="form.contractendate"
                type="date"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>

      <el-form-item  v-if="formEdit">
        <el-button
                type="primary"
                :loading="loading"
                @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
import * as agentService from '@/api/sys/agent'
import * as userService from '@/api/sys/user'
import util from '@/libs/util.js'
export default {
  name: 'oneagentEditForm',
  props: {
    oneagent: Object,
    value: Boolean
  },
  data () {
    return {
      formEdit: true,
      formEdit2: true,
      loading: false,
      dialogVisible: false,
      pickerOptions: {}, // 日期设置对象
      form: {
        businessid: '',
        businessname: '',
        contractno: '',
        identification_number: '',
        identification_start: '',
        identification_end: '',
        identification_end2: false,
        industry_license: '',
        account_name: '',
        bank_account: '',
        bank_branch: '',
        idcards_front: '',
        idcards_back: '',
        sort_id: ''
      },
      sfzlxOptions: [
        {
          value: '身份证',
          label: '身份证'
        },
        {
          value: '台湾身份证',
          label: '台湾身份证'
        },
        {
          value: '香港身份证',
          label: '香港身份证'
        },
        {
          value: '澳门身份证',
          label: '澳门身份证'
        },
        {
          value: '港澳台通行证',
          label: '港澳台通行证'
        }
      ],
      areaname2: '',
      imgUrl: process.env.VUE_APP_API + '/moblieapp/currencyUpload',
      fileList4: [],
      fileList5: [],
      fileList6: [],
      typeOptions: [],
      typeOptions2: [],
      typeOptions3: [],
      typeOptions_yh: [],
      typeOptions2_yh: [],
      typeOptions3_yh: []
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
    },
    dialogVisible (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    dialogOpen () {
      this.$refs.form.resetFields()
      this.areaname2 = ''
      var formData2 = new FormData() // 声明一个FormData对象
      agentService.getProvcd(formData2).then(data => {
        this.typeOptions = data
      })
      agentService.getProvcd(formData2).then(data => {
        this.typeOptions_yh = data
      })
      if (this.oneagent.city) {
        this.currentSel(this.oneagent.prov_cd)
      }
      if (this.oneagent.areaid) {
        this.currentSel2(this.oneagent.city)
      }
      if (this.oneagent.userId) {
        // userService.getUser(this.user.id).then(data => {
        var formData4 = new FormData() // 声明一个FormData对象
        formData4.append('agentid', this.oneagent.agentid)
        agentService.getPerfectAgent(formData4).then(data => {
          if (data != null && data != '') {
            let form = {}
            form.userCode = this.oneagent.userCode
            form.legal = this.oneagent.legal
            form.userName = this.oneagent.agentname
            form.mobileNo = this.oneagent.mobileNo
            // form.wechat_no = this.oneagent.wechat_no;
            form.prov_cd = this.oneagent.prov_cd
            form.city = this.oneagent.city
            form.areaid = this.oneagent.areaid
            form.compaddress = this.oneagent.compaddress

            if (data.contractno != null && data.contractno != '' && data.contractno != 'null') {
              form.contractno = this.oneagent.contractno
            }

            form.contractstdate = this.oneagent.contractstdate
            form.contractendate = this.oneagent.contractendate
            //  form.identification_number =  data.identitynum;

            /** form.identification_start =  data.identification_start;
                                if (data.identification_end != null && data.identification_end != "" && data.identification_end != "null") {
                                    if(data.identification_end == "长期"){
                                        form.identification_end2 =  true;
                                    }else{
                                        form.identification_end =   data.identification_end;
                                    }

                                }

                                if (data.account_name != null && data.account_name != ""&& data.account_name != "null") {
                                    form.account_name = data.account_name;
                                }
                                if (data.bank_account != null && data.bank_account != ""&& data.bank_account != "null") {
                                    form.bank_account = data.bank_account;
                                }

                                if (data.bank_branch != null && data.bank_branch != ""&& data.bank_branch != "null") {
                                    form.bank_branch = data.bank_branch;
                                }
                                if (data.idcards_front != null && data.idcards_front != ""&& data.idcards_front != "null") {
                                    this.fileList4 = [{url: 'https://cos.shxgkj.cn/' + data.idcards_front}]
                                    form.idcards_front = data.idcards_front;
                                }else{
                                    this.fileList4 =[];
                                }

                                if (data.idcards_back != null && data.idcards_back != ""&& data.idcards_back != "null") {
                                    this.fileList5 = [{url: 'https://cos.shxgkj.cn/' + data.idcards_back}]
                                    form.idcards_back = data.idcards_back;
                                }else{
                                    this.fileList5 =[];
                                }

                                if (data.industry_license != null && data.industry_license != ""&& data.industry_license != "null") {
                                    this.fileList6 = [{url: 'https://cos.shxgkj.cn/' + data.industry_license}]
                                    form.industry_license = data.industry_license;
                                }else{
                                    this.fileList6 =[];
                                }**/

            this.form = form
          }
        })
        this.formEdit = true
        this.formEdit2 = false
      } else {
        this.fileList4 = []
        this.fileList5 = []
        this.fileList6 = []
        this.formEdit = true
        this.formEdit2 = true
        this.form = {}
      }
    },
    // 上传文件之前的钩子
    handleBeforeUpload (file) {
      let isJPG = true
      // this.$message('上传模板只能是.jpg .jpeg .gif .png .bmp格式!');
      console.log('before')
      if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        isJPG = false
        this.$notify.warning({
          title: '警告',
          message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
        })
      }
      let size = file.size / 1024 / 1024 / 2
      if (size > 2) {
        this.$notify.warning({
          title: '警告',
          message: '图片大小必须小于2M'
        })
        isJPG = false
      }

      return isJPG // 返回false不会自动上传
    },
    // 点击文件列表中已上传的文件时的钩子
    handleRemove3 (file) {
      this.form.idcards_back = ''
      this.dialogVisible = true
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview3 (file) {
      console.log('=======file.url==========' + file.url)
      this.form.idcards_back = file.url
      this.dialogVisible = true
    },
    handleRemove7 (file) {
      this.form.industry_license = ''
      this.dialogVisible = true
    }, // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview7 (file) {
      console.log('=======file.url==========' + file.url)
      this.form.industry_license = file.url
      this.dialogVisible = true
    }, // 点击文件列表中已上传的文件时的钩子
    // 点击文件列表中已上传的文件时的钩子
    handleRemove2 (file) {
      this.form.idcards_front = ''
      this.dialogVisible = true
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview2 (file) {
      console.log('=======file.url==========' + file.url)
      this.form.idcards_front = file.url
      this.dialogVisible = true
    },
    currentSel_yh (val) {
      let obj = {}
      obj = this.typeOptions_yh.find((item) => {
        return item.areaid === val
      })
      this.areaname2 = obj.areaname
      this.typeOptions2_yh = []
      var formData2 = new FormData() // 声明一个FormData对象

      formData2.append('type', 'city')
      formData2.append('areaid', val)
      agentService.getProvcd(formData2).then(data => {
        this.typeOptions2_yh = data
      })
    },
    currentSel (val) {
      if (this.oneagent.userId) {
        this.form.city = ''
        this.form.areaid = ''
      }
      this.typeOptions2 = []
      var formData2 = new FormData() // 声明一个FormData对象

      formData2.append('type', 'city')
      formData2.append('areaid', val)
      agentService.getProvcd(formData2).then(data => {
        this.typeOptions2 = data
      })
    },
    currentSel2 (val) {
      this.typeOptions3 = []
      var formData2 = new FormData() // 声明一个FormData对象
      formData2.append('type', 'area')
      formData2.append('areaid', val)
      agentService.getProvcd(formData2).then(data => {
        this.typeOptions3 = data
      })
    },
    currentSel2_yh (val) {
      this.typeOptions3_yh = []
      if (this.form.deposit_bank != null && this.form.deposit_bank != '') {
        let obj = {}
        obj = this.typeOptions2_yh.find((item) => {
          return item.areaid === val
        })

        var formData2 = new FormData() // 声明一个FormData对象
        formData2.append('sf', this.areaname2)
        formData2.append('ds', obj.areaname)
        formData2.append('kfh', this.form.deposit_bank)
        agentService.getProvcdYh(formData2).then(data => {
          this.typeOptions3_yh = data
        })
      } else {
        this.typeOptions3_yh = []
        this.$message('开户行不能为空')
      }
    },
    saveUser () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.oneagent.userId) {
            this.loading = true
            agentService.saveAgent({ ...this.form, agentid: util.cookies.get('agentid'), id: this.oneagent.userId, agentids: this.oneagent.agentid })
              .then(data => {
                if (data != null && data != '') {
                  this.loading = false
                } else {
                  this.loading = false
                  this.dialogVisible = false
                  this.$emit('submit')
                }
              })
          } else {
            userService
              .getCheckUser({ userCode: this.form.userCode })
              .then(data2 => {
                console.log('=========data2:' + data2)
                if (data2 == 'true') {
                  this.loading = true
                  agentService.saveAgent({ ...this.form, agentid: util.cookies.get('agentid'), id: this.oneagent.userId, agentids: this.oneagent.agentid, dl_type: '0', xt_id: util.cookies.get('xt_id') })
                    .then(data => {
                      if (data != null && data != '') {
                        this.loading = false
                      } else {
                        this.loading = false
                        this.dialogVisible = false
                        this.$emit('submit')
                      }
                    })
                } else {
                  this.$message('该账号已存在,请更换账号试试')
                }
              })
          }
        } else {
          return false
        }
      })
    },
    close () {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>
